import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Space, Table } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

import { BonusWagerAPI } from "@/api";
import { useExportHandler, useImportHandler } from "@/hooks";
import Query from "@/models/query";

function BonusWagers() {
  const [getAllQuery] = useState(() => new Query(BonusWagerAPI.getAll));
  const [importQuery] = useState(() => new Query(BonusWagerAPI.import));
  const [exportQuery] = useState(() => new Query(BonusWagerAPI.export));

  const handleImportClick = useImportHandler({ getAllQuery, importQuery });

  const handleExportClick = useExportHandler({
    exportQuery,
    fileName: "bonus-wagers.csv",
  });

  useEffect(() => {
    getAllQuery.submit();
  }, [getAllQuery]);

  return (
    <Space direction="vertical">
      <Card size="small">
        <Row gutter={[12, 12]} wrap={true}>
          <Col>
            <Button
              icon={<DownloadOutlined />}
              loading={importQuery.isPending}
              onClick={handleImportClick}
            >
              {"Import"}
            </Button>
          </Col>
          <Col>
            <Button
              icon={<UploadOutlined />}
              loading={exportQuery.isPending}
              onClick={handleExportClick}
            >
              {"Export"}
            </Button>
          </Col>
        </Row>
      </Card>
      <Card size="small">
        <Table
          loading={getAllQuery.isPending}
          dataSource={getAllQuery.isFulfilled ? getAllQuery.data.data : []}
          pagination={false}
          size="small"
          rowKey={(bonusWager) =>
            `${bonusWager.gameName}_${bonusWager.providerName}`
          }
        >
          <Table.Column title={"Provider"} dataIndex="providerName" />
          <Table.Column title={"Game"} width="100%" dataIndex="gameName" />
          <Table.Column title={"Wager"} dataIndex="value" />
        </Table>
      </Card>
    </Space>
  );
}

export default observer(BonusWagers);
